module.exports = "/static/img/we_work_with_3.svg?18375ea90e6444d964c3fed0dd96c978";